import React from 'react'
import styles from './Classifications.module.css'

import PropTypes from 'prop-types'

import {
  TextField,
  Button
} from '@material-ui/core'

class ClassificationsForm extends React.Component {
  render() {
    return (
      <div>
        <form>
          <div className={styles.groupFields}>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="name"
              fullWidth="true"
              label="Name"
              onChange={this.props.onchange}
              value={this.props.item.name}
            />

            <TextField
              autoComplete="off"
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="short_name"
              fullWidth="true"
              label="Short Title"
              onChange={this.props.onchange}
              value={this.props.item.short_name}
              id="short_title"
            />
          </div>
        </form>

        <div className={styles.actionButton}>
          <Button variant="outlined"
                  id="classification-submit" color="primary"
                  disabled={!this.props.item.name && !this.props.item.short_name}
                  onClick={() => this.props.submit()}>Save</Button>
        </div>
      </div>
    )
  }
}

export default ClassificationsForm

ClassificationsForm.propTypes = {
  onchange: PropTypes.func,
  handleAutocomplete: PropTypes.func,
  handleSwitch: PropTypes.func,
  branches: PropTypes.array,
  departments: PropTypes.array,
  item: PropTypes.object,
  updateBranch: PropTypes.object,
  updateDepartment: PropTypes.object,
  submit: PropTypes.func
}
